
export default htmlToPlain;

function normalizeHtml(html) {
  return html.replace("\n", "<br>")
}

function htmlToPlain(html) {
  html = normalizeHtml(html)
  return unescape(html.replace(/<br>/gm, "\n").replace(/<\/?[^>]*>/gm, ""))
}
